import { render, staticRenderFns } from "./CurriculumGroup_list.vue?vue&type=template&id=40a65d7a&scoped=true"
import script from "./CurriculumGroup_list.vue?vue&type=script&lang=js"
export * from "./CurriculumGroup_list.vue?vue&type=script&lang=js"
import style0 from "./CurriculumGroup_list.vue?vue&type=style&index=0&id=40a65d7a&prod&scoped=true&lang=css"
import style1 from "./CurriculumGroup_list.vue?vue&type=style&index=1&id=40a65d7a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40a65d7a",
  null
  
)

export default component.exports